import { useMemo } from 'react';
import { MdOutlineWarning } from 'react-icons/md';
import { useBaseCaseDetails } from '@/hooks/useBaseCaseDetails';
import { MultiSuggestRoutePlanType } from '@/utils/route/chains';
import { convertToTimezoneOffset, dateTimeToISO } from '@/utils/helpers';

type SuggestInfoWarningsProps = {
  data: MultiSuggestRoutePlanType;
};

export const SuggestInfoWarnings = ({ data }: SuggestInfoWarningsProps) => {
  const { donorHospitalDate, donorHospitalTime, donorHospitalTimeZone } = useBaseCaseDetails();

  const orDiffString = useMemo(() => {
    if (!data.orTime || !donorHospitalDate || !donorHospitalTime || !donorHospitalTimeZone) return 0;

    const currentOrTimeUTC = dateTimeToISO(donorHospitalDate, donorHospitalTime, donorHospitalTimeZone);
    const currentOrTimeMs = new Date(currentOrTimeUTC).getTime();
    const suggestedOrTimeMs = new Date(data.orTime).getTime();

    if (suggestedOrTimeMs === currentOrTimeMs) return '';

    const relativityString = suggestedOrTimeMs > currentOrTimeMs ? 'after' : 'before';
    const diffString = convertToTimezoneOffset(suggestedOrTimeMs - currentOrTimeMs, false);

    return `${diffString}h ${relativityString}`;
  }, [data.orTime, donorHospitalDate, donorHospitalTime, donorHospitalTimeZone]);

  const isNoCommercialWarning = data.hasFakeCommercialFlights && !data.hasRealCommercialFlight;

  return (
    <>
      {!!orDiffString && (
        <div className="flex gap-2 items-center max-w-full">
          <div className="text-warning-30">
            <MdOutlineWarning size={16} />
          </div>
          <span className="text-s-r text-base-10">The ETA to Donor Hospital is {orDiffString} current OR time</span>
        </div>
      )}
      {isNoCommercialWarning && (
        <div className="flex gap-2 items-center">
          <div className="text-warning-30">
            <MdOutlineWarning size={16} />
          </div>
          <span className="text-s-r text-base-10">No Commercial flights found</span>
        </div>
      )}
    </>
  );
};
